import $ from "jquery";
import { PRODUCT_UID_ATTR } from "@/constants/selectors";
import { boundActions } from "@/store/actions";
import { getProducts } from "@/api";
/**
 * @param {*} productsJqElements
 * @param {*} logger
 */
export function loadRatings(productsJqElements, logger) {
  const productsIds = productsJqElements
    .toArray()
    .map((el) => $(el).attr(PRODUCT_UID_ATTR))
    .filter(Boolean);

  logger.info("loadRatings starts", { productsIds, productsJqElements });

  getProducts(productsIds)
    .then((productsData) => {
      const loadedProductsData = productsData.reduce((acc, val) => {
        const productJqElement = productsJqElements
          .filter((_, el) => $(el).attr(PRODUCT_UID_ATTR) === val.uid)
          .eq(0);
        return {
          ...acc,
          [val.uid]: {
            ...val,
            ...{
              image: productJqElement
                .find(".js-product-img")
                .first()
                .attr("data-original"),
              name: productJqElement.find(".js-product-name").first().text(),
              price: Number.parseFloat(
                productJqElement
                  .find(".js-store-prod-price-val")
                  .first()
                  .text()
                  .replaceAll(" ", "")
                  .replaceAll(".", "")
                  .replaceAll(",", "")
                  .trim()
              ),
            },
          },
        };
      }, {});

      productsIds.forEach((uid, idx) => {
        const productJqElement = productsJqElements.eq(idx);

        if (loadedProductsData[uid] === undefined) {
          loadedProductsData[uid] = {
            rating: 0,
            reviews_count: 0,
            image: productJqElement
              .find(".js-product-img")
              .first()
              .attr("data-original"),
            name: productJqElement.find(".js-product-name").first().text(),
            price: Number.parseFloat(
              productJqElement
                .find(".js-store-prod-price-val")
                .first()
                .text()
                .replaceAll(/\D/gm, "")
                .replaceAll(" ", "")
                .replaceAll(".", "")
                .replaceAll(",", "")
                .trim()
            ),
            uid,
          };
        }
      });

      boundActions.setProducts(loadedProductsData);

      logger.info("loadRatings finish");
    })
    .catch((err) => {
      logger.error("loadRatings error", err);
    });
}
